export default "__VITE_ASSET__DfiTJHrz__"